import { Component, Inject, InjectionToken } from '@angular/core';
import { ToastHostComponent } from './toast-host/toast-host.component';

@Component({
  template: '',
  standalone: false
})
export abstract class ToastBaseComponent<T extends ToastDataBaseComponent> {
  constructor(
    @Inject(TOAST_DATA_INJECTION_TOKEN) public data: T) {
  }
}

export abstract class ToastDataBaseComponent {
  userCanDismiss: boolean;
  host: ToastHostComponent;
  index: number;
}

export const TOAST_DATA_INJECTION_TOKEN = new InjectionToken<any>('TOAST_DATA_INJECTION_TOKEN');
